import styled from 'styled-components';
export const StyledWrapper = styled.div ``;
//# sourceMappingURL=Transition.style.js.map